"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReversedSortOrders = exports.GenerateTrailerStatus = void 0;
var GenerateTrailerStatus;
(function (GenerateTrailerStatus) {
    GenerateTrailerStatus["Pending"] = "pending";
    GenerateTrailerStatus["InQueue"] = "in-queue";
    GenerateTrailerStatus["InProgress"] = "in-progress";
    GenerateTrailerStatus["PreviewReady"] = "preview-ready";
    GenerateTrailerStatus["Ready"] = "ready";
    GenerateTrailerStatus["Failed"] = "failed";
})(GenerateTrailerStatus = exports.GenerateTrailerStatus || (exports.GenerateTrailerStatus = {}));
var ReversedSortOrders;
(function (ReversedSortOrders) {
    ReversedSortOrders["ReverseCustom"] = "-custom";
    ReversedSortOrders["ReverseRelevance"] = "-relevance";
    ReversedSortOrders["ReverseDate"] = "-date";
    ReversedSortOrders["ReverseName"] = "-name";
})(ReversedSortOrders = exports.ReversedSortOrders || (exports.ReversedSortOrders = {}));
//# sourceMappingURL=video.types.js.map